import * as React from "react";
import { NavLink } from "react-router";
import { motion } from "framer-motion";
import { clsx } from "clsx";

export interface NavItemProps {
  href: string;
  active?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  children: React.ReactNode;
  variant?: "desktop" | "mobile";
}

export const NavItem = ({
  href,
  active = false,
  onClick,
  onMouseEnter,
  children,
  variant = "desktop",
}: NavItemProps) => {
  const baseClasses =
    variant === "mobile"
      ? "min-h-12 w-full rounded-md px-4 text-base flex items-center font-medium transition-colors"
      : "rounded-sm px-4 py-2.5 text-sm flex items-center font-medium transition-colors";

  const stateClasses = active
    ? "bg-accent-bg text-accent font-semibold"
    : "text-secondary hover:text-primary";

  return (
    <motion.div whileTap={{ scale: 0.98 }} className="relative">
      <NavLink
        to={href}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        end={href === "/"}
        className={clsx(baseClasses, stateClasses)}
      >
        {children}
      </NavLink>
    </motion.div>
  );
};
